module.exports = __webpack_public_path__ + "img/yypp.e5323ac3.png";